import React, { Component } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import './ScoreBar.scss';

const getProgressCssClass = (score) => {
  if (score < 33) {
    return 'progress-bar bg-danger';
  } else if (score < 66) {
    return 'progress-bar bg-warning';
  } else {
    return 'progress-bar bg-success';
  }
};

const averageScore = (scores) => {
  if (scores.length === 0) return 'N/A';
  return Math.round((scores.reduce((acc, cur) => {
    console.log('Inner Inner', cur.skill_score);
    return acc + parseFloat(cur.skill_score);
  }, 0) / scores.length) * 100) / 100;
};

class ScoreBar extends Component {
  render () {
    return (
      <div className='student-report-score-list-scorebar' key={this.props.entry.id}>
        <p>
          <span>{this.props.entry.skill_name}</span>
          {this.props.entry.skill_description && (
            <span>
              &nbsp;
              <i className='fa fa-info-circle' id={`infobox-${this.props.entry.id}`} aria-hidden='true' />
              <UncontrolledTooltip target={`infobox-${this.props.entry.id}`}>{this.props.entry.skill_description}</UncontrolledTooltip>
            </span>
          )}
        </p>
        <div className='progress'>
          <div className={getProgressCssClass(averageScore(this.props.entry.skill_scores))} style={{ 'width': `${averageScore(this.props.entry.skill_scores)}%` }} role='progressbar' />
        </div>
      </div>
    );
  }
}

export default ScoreBar;



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/ScoreList/components/ScoreBar/index.js